import { cn } from '@/lib/utils';
import type { AttendanceStatus } from '../types/attendance.types';
import { STATUS_COLORS } from '../constants/attendance.constants';

interface StatusBadgeProps {
  status: AttendanceStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center size-8 rounded-full text-sm font-bold',
        STATUS_COLORS[status].badge,
      )}
    >
      {status}
    </span>
  );
}
